import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TweenMax, Quint } from 'gsap';
import { EventTypes } from '../../../shared/EventTypes';
import { ChangeSecurityQuestionsEventType } from '../change-security-questions.event.type';
import { ChangeSecurityQuestionsService } from '../change-security-questions.service';
import { ChangeSecurityQuestions } from '../model/change-security-questions';
import { AutenticationService } from '../../../autentication/autentication.service';
import { Auth } from '../../../autentication/Auth';

@Component({
	selector: 'app-change-questions-confirm',
	templateUrl: './change-questions-confirm.component.html',
	styleUrls: ['./change-questions-confirm.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class ChangeQuestionsConfirmComponent implements OnInit, OnDestroy {

	@Input() submited: boolean;
	@Input() changeQuestionsData: ChangeSecurityQuestions;
	@Output() onSetForm: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
	@Output() showStepButtons: EventEmitter<boolean> = new EventEmitter<boolean>();

	private view = '[data-component="change-questions-confirm"]';
	private sendConfirmedQuestions = false;
	public formSignature: FormGroup;
	public active = false;
	public disabled = false;

	constructor(private autenticationService: AutenticationService,
		private changeSecurityQuestionsService: ChangeSecurityQuestionsService) {
	}

	ngOnInit() {
		this.showStepButtons.emit(false);

		AppEventDispatcher.listen( ChangeSecurityQuestionsEventType.STEPS.CHANGE_SECURITY_QUESTIONS_CONFIRM, () => {
			this.active = true;
			this.show();
		});

		AppEventDispatcher.listen(ChangeSecurityQuestionsEventType.SEND.CHANGE_SECURITY_QUESTIONS_CONFIRM_SEND, () => {
			this.send();
		});
	}

	keyDownHandler(event: Event) {
		event.preventDefault();
	}

	show() {
		const interval = setInterval(() => {

			if ($(this.view).length > 0) {
				const containerHeight = this.getStepHeight();

				TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut});
				TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut});
				TweenMax.to('.buttons', .8, {delay: .8, left: 0, bottom: 0, ease: Quint.easeOut});

				clearInterval(interval);
			}

		}, 10);
	}

	getStepHeight(): number {
		return $(this.view).outerHeight() + $('.buttons').outerHeight() + 60;
	}

	addAuthToken() {
		Auth.passToken = this.formSignature.value.token ? this.formSignature.value.token : '';
		Auth.assinaturaEletronica = this.formSignature.value.eletronicSignature ? this.formSignature.value.eletronicSignature : '';
	}

	send() {
		this.submited = true;
		if (this.formSignature.valid) {

			this.preload(true);
			this.disabled = true;
			this.submited = false;

			this.autenticationService.sendDigitalSignature(this.formSignature.value.eletronicSignature).subscribe(d => {
				if (d.Sucesso) {
					this.hide();
				}
			}, error => {
				this.preload(false);
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
				this.disabled = false;
			});
		}
	}

	hide() {
		TweenMax.delayedCall(1, () => {
			this.changeSecurityQuestionsService.getSmsCode().subscribe( sms => {
				this.preload(false);
				AppEventDispatcher.dispatch(ChangeSecurityQuestionsEventType.LOGIN.SMS_VALIDATION, { show: true, sms: sms });
				TweenMax.to(this.view, .8, { delay: .4, left: '-100%', ease: Quint.easeOut, onComplete: () => {
					this.active = false;
				}});
				TweenMax.to('.buttons', .8, {delay: .8, bottom: '-100%', bo: 0, ease: Quint.easeOut });
			});
		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener( ChangeSecurityQuestionsEventType.SEND.CHANGE_SECURITY_QUESTIONS_CONFIRM_SEND);
		AppEventDispatcher.removeListener( ChangeSecurityQuestionsEventType.STEPS.CHANGE_SECURITY_QUESTIONS_CONFIRM);
	}

	onSetSignatureForm(form: FormGroup) {
		this.formSignature = form;

		if (this.sendConfirmedQuestions) {
			this.send();
		}
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD,
			{element: '[data-component="change-security-questions"] .content', show: active, delay: delay});
	}

	public getMessageConfirmedQuestions(message: boolean) {
		this.sendConfirmedQuestions = message;
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/change-security-questions/change-questions-confirm/change-questions-confirm.component.ts